class ValidateWebsiteUrl extends ValidatePage {
    constructor(_parent) {
        // this.debug = true; // uncomment for debug obj
        super();
        this.parent = _parent;
        this.regex = /^(?:http(s)?:\/\/)?[a-zA-Z0-9._%-+#]+(?:\.[#\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gi;
        this.url = { elm: '', id: '', classlist: '',  value: '' };
        this.type = { elm: '', id: '', classlist: '', value: '' };
        this.is_valid = false;

        this.debug = this.parent.debug.extends.ValidateWebsiteUrl; // Turn on debugger in ValidatePage
    }  

    _validate($this){
        this.define_elems($this);
        this.is_valid = this.process_validations();

        if(this.debug)
            console.log(this, "ValidateWebsiteUrl - debug");

        return this.is_valid
    }

    define_elems($this){
        if($this.hasClass('js-website-url')){
            this.url = this.parent.define_elem($this);
            this.type = this.get_website_type($this);
        }

        if($this.hasClass('js-website-type')){
            this.type = this.parent.define_elem($this);
            this.url = this.get_website_url($this);
        }
    }

    process_validations(){
        const select_allowed_values = ['website', 'blog', 'store', 'account', 'personal'];
        let cond = 1;

        if(this.url.value == ''){
            select_allowed_values.includes(this.type.value) ? cond = 2 : cond = 1
        }else{
            if(this.regex.test(this.url.value))
                select_allowed_values.includes(this.type.value) ? cond = 1 : cond = 3
            else
                cond = 4
        }


        return this.format_ret_obj(cond);
    }

    format_ret_obj(cond){
        var obj = {passed: '', all: false,  msg: '' };
        if(cond === 1){
            obj.passed = true;
        }
        else if(cond === 2) {
            obj.passed = false;
            obj.elm = this.url.elm;
            obj.msg = get_language_translation('URL_FORMAT_REQUIRES_LANG');
        }
        else if(cond == 3){
            obj.passed = false;
            obj.elm = this.type.elm;
            obj.msg = get_language_translation('REQUIRED_FIELD_LANG');
        }
        else{
            obj.passed = false;
            obj.all = true;
            obj.all = [
                {
                    elm: this.url.elm,
                    msg: get_language_translation('URL_FORMAT_REQUIRES_LANG')
                },
                {
                    elm: this.type.elm,
                    msg: get_language_translation('REQUIRED_FIELD_LANG')
                }
            ]
        }

        return obj;
    }

    get_website_container($el){
        const $websiteContiner = $el.parent().closest('.am-section-section');
        return $websiteContiner;
    }
        
    get_website_type($el){
        const $websiteContiner = this.get_website_container($el);
        const $websiteType = $websiteContiner.find('select.js-website-type');
        var type = this.parent.define_elem($websiteType);
    
       return type
    }
    
    get_website_url($el){
        const $websiteContiner = this.get_website_container($el);
        const $websiteUrl = $websiteContiner.find('.js-website-url');
        var url = this.parent.define_elem($websiteUrl);
    
       return url;
    }
} 